import { useCallback } from 'react';

import { emitMixpanelUserEvent, UserTrackingEvents } from '@revelio/core';

import { useOptionalRevelioPageId } from '../../components/PageConfigProvider/PageConfigProvider';

/**
 * Which filter-area tooltip opened — the id the boards group `tooltip open` by.
 *
 * Only tooltips that describe the filter's own subject matter earn an event:
 * `filter_branch_description` is the (i) on a tree's level headers, which
 * explains what a company / role / geography level of the taxonomy means.
 * The filter menus' generic UI hints (the keywords format hint, "this filter
 * is unavailable", the disabled-submit reason, "manage available filters")
 * are deliberately NOT tracked — they say nothing about the data.
 */
export type FilterTooltipId = 'filter_branch_description';

/**
 * `tooltip open` for the filter area. `emitMixpanelUserEvent` throttles per
 * (tooltip, filter, page), so a hover that flickers does not flood the stream.
 */
export const useTrackFilterTooltip = () => {
  const pageId = useOptionalRevelioPageId();

  return useCallback(
    (tooltipId: FilterTooltipId, filterId?: string) => {
      emitMixpanelUserEvent(UserTrackingEvents.TOOLTIP_OPEN, {
        tooltip_id: tooltipId,
        ...(filterId !== undefined && { filter_id: filterId }),
        ...(pageId !== undefined && { page_id: pageId }),
      });
    },
    [pageId]
  );
};
